import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { APIKey } from '../models/api-key';
import { DeletionConfirmationService } from '../util/confirmation/confirmation.service';
import {
  DefaultEntityListStore,
  EntityListComponent,
  defaultEntityListStoreProvider,
} from '../util/entity-list/entity-list.base';
import { EventsServiceManager } from '../util/events.service';
import { STORE_SERVICE_TOKEN } from '../util/store.service';
import { ApiKeyDetailsComponent } from './api-key-details/api-key-details.component';
import { ApiKeyTypesService } from './api-key-types.service';
import { APIKeysService } from './api-keys.service';

class ApiKeyDeletionConfirmer extends DeletionConfirmationService<APIKey> {
  getConfirmDeleteEntityMessage(apiKey: APIKey): string {
    return `All integrations using this key will no longer be authorized. Are you sure you want to delete API Key '${apiKey.name}'?`;
  }

  getEntityDeletedMessage(apiKey: APIKey): string {
    return `API key ${apiKey.name} deleted`;
  }
}

@Component({
  selector: 'app-api-keys',
  templateUrl: './api-keys.component.html',
  styleUrls: ['./api-keys.component.scss'],
  providers: [defaultEntityListStoreProvider('api-keys.component')],
})
export class ApiKeysComponent
  extends EntityListComponent<APIKey, {}>
  implements OnInit, OnDestroy
{
  displayedColumns = ['name', 'type', 'actions'];

  typeMap = {};

  constructor(
    apiKeysService: APIKeysService,
    private apiKeyTypesService: ApiKeyTypesService,
    @Inject(STORE_SERVICE_TOKEN)
    store: DefaultEntityListStore,
    eventsServiceManager: EventsServiceManager,
    private dialog: MatDialog
  ) {
    super(
      apiKeysService,
      store,
      new ApiKeyDeletionConfirmer(apiKeysService, dialog, eventsServiceManager)
    );
  }

  getTableId(): string {
    return 'apikeys-table';
  }

  getTypeName(typeId: string) {
    return this.typeMap[typeId];
  }

  isExpired(apiKey: APIKey) {
    return apiKey.expires_at ? apiKey.expires_at <= new Date() : false;
  }

  ngOnInit() {
    super.ngOnInit();

    this.apiKeyTypesService
      .getAll()
      .pipe(
        map((types) =>
          types.reduce((acc, curr) => {
            acc[curr.id] = curr.name;
            return acc;
          }, {})
        )
      )
      .subscribe((typeMap) => (this.typeMap = typeMap));
  }

  getDetails(ApiKey: APIKey) {
    const detailsDialog = this.dialog.open(ApiKeyDetailsComponent, {
      data: {
        apiKey: ApiKey,
      },
      minWidth: '375px',
      height: 'fit-content',
      maxHeight: 'fit-content',
    });
    detailsDialog.afterClosed().subscribe((val) => {
      if (val) {
        this.confirmDeleteEntity(val);
      }
    });
  }
}
